<script>
	import Leader from '$lib/icons/leadership-svgrepo-com.svelte';
	import Group from '$lib/icons/group-svgrepo-com.svelte';
	import Move from '$lib/icons/move-up-svgrepo-com_change.svelte';
</script>

<div class="content-div">
	<span class="chip static-courser bg-[#D17208] mt-4 text-white"><b>WP 1</b></span>
	<div class="flex">
		<h1 class="content-heading">Regional projections of future climate change</h1>
		<Move />
	</div>

	<blockquote class="content-blockquote">
		This WP will set the data foundation that is needed to derive the climate indicators for the
		analysis of climate impacts (WP2), regional tipping points (WP4) and the web-portal based
		climate services (WP3).
	</blockquote>

	<div class="flex pt-10">
		<Leader />
		<div class="pl-4 text-lg">
			<a class="anchor" href="/team/#torsten_weber">Torsten Weber (GERICS)</a>
		</div>
	</div>

	<div class="flex pt-4">
		<Group />
		<div class="pl-4 text-lg"><a class="anchor" href="/team/#gerics">GERICS</a></div>
		<div class="pl-4 text-lg"><a class="anchor" href="/team/#wits_gci">WITS-GCI</a></div>
	</div>

	<h2 class="h4 pt-10 pb-2">Objectives</h2>
	This WP will set the data foundation that is needed to derive the climate indicators for the analysis
	of climate impacts (WP2), regional tipping points (WP4) and the web-portal based climate services (WP3).
	For this purpose, we will make use of the already existing but growing CMIP6 archive of global projections
	of future climate change, as well as the regional climate projections of CORDEX and the new initiative
	CORDEX-CORE. Moreover, a new set of high-resolution regional climate change projections will be generated
	with the new coupled ocean-atmosphere RCMs CCAM (WITS-GCI) and ROM (GERICS) using CMIP6 data as forcing.
	In order to build up an ensemble of regional climate change projections, the RCMs CCAM and ROM will
	downscale selected CMIP6 projections to a spatial resolution of about 8 km for a selected domain in
	southern Africa. These will be the first coupled ocean-atmosphere projections of future climate change
	ever obtained for the southern African region, and will include feedbacks between the Agulhas current
	and Benguela upwelling system and atmospheric circulation over southern Africa. The newly performed
	regional climate change projections will be stored at a public database and made available for other
	scientists from different sectors and SASSCAL projects. This dissemination will take place through
	the project’s Climate Service Gateway (WP3).
</div>
